var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "duration",
    transform: "translate(-1202 -2109)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2368",
    "data-name": "Rectangle 2368",
    width: 20,
    height: 20,
    transform: "translate(1202 2109)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "queue",
    transform: "translate(1206 2113.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8373",
    "data-name": "Path 8373",
    d: "M9.183,6a3.183,3.183,0,1,0,3.183,3.183A3.187,3.187,0,0,0,9.183,6Zm1.486,4.563a.53.53,0,0,1-.742.106L8.866,9.741a.529.529,0,0,1-.212-.424V7.592a.531.531,0,1,1,1.061,0V9.051l.849.769a.531.531,0,0,1,.106.743Z",
    transform: "translate(-2.817 -2.817)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8374",
    "data-name": "Path 8374",
    d: "M.8,6.366A5.568,5.568,0,0,1,9.408,1.7l-.8.8a.4.4,0,0,0,.281.679h2.388a.4.4,0,0,0,.4-.4V.4a.4.4,0,0,0-.679-.281L9.978,1.132A6.309,6.309,0,0,0,6.367,0,6.364,6.364,0,0,0,.272,8.205a.4.4,0,1,0,.762-.23A5.563,5.563,0,0,1,.8,6.366Z",
    transform: "translate(0 0)",
    fill: "#3f2566"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8375",
    "data-name": "Path 8375",
    d: "M13.4,8.283a.4.4,0,1,0-.762.23A5.569,5.569,0,0,1,4.27,14.791l.8-.808a.4.4,0,0,0-.283-.678H2.4a.4.4,0,0,0-.283.118A.4.4,0,0,0,2,13.708L2.027,16.1a.4.4,0,0,0,.681.275l1-1.008a6.306,6.306,0,0,0,3.6,1.126A6.364,6.364,0,0,0,13.4,8.283Z",
    transform: "translate(-0.939 -3.756)",
    fill: "#3f2566"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.623e78810e6cbdc4336afc7872c87bca.svg";
export { ForwardRef as ReactComponent };